import React, { useEffect, useState } from "react"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fas }     from "@fortawesome/free-solid-svg-icons"
library.add(fas)

import QlineGroupFormModal from "./QlineGroupFormModal"

// Mounted once on the Ouvrages index. Any element carrying
// data-ouvrage-open="create" | "edit" (with data-ouvrage-id for edit) opens
// the React form modal — delegated on document so it works for every row and
// survives DOM updates. On save we reload the current URL so the ERB table
// (search / sort / page preserved) reflects the change.
const FormModalManager = ({ indexUrl, qlineServiceBlueprintOptions }) => {
  const [state, setState] = useState(null) // { mode, id } | null

  useEffect(() => {
    const onClick = event => {
      const trigger = event.target.closest("[data-ouvrage-open]")
      if (!trigger) return
      event.preventDefault()
      const mode = trigger.getAttribute("data-ouvrage-open")
      const id   = trigger.getAttribute("data-ouvrage-id")
      setState({ mode: mode === "edit" ? "edit" : "create", id: id ? Number(id) : null })
    }
    document.addEventListener("click", onClick)
    return () => document.removeEventListener("click", onClick)
  }, [])

  const close = () => setState(null)
  const base  = indexUrl.replace(/\/$/, "")

  return (
    <QlineGroupFormModal
      isOpen    = {state !== null}
      mode      = {state?.mode}
      groupId   = {state?.id}
      showUrl   = {state?.id ? `${base}/${state.id}.json` : null}
      saveUrl   = {`${base}.json`}
      updateUrl = {state?.id ? `${base}/${state.id}.json` : null}
      qlineServiceBlueprintOptions = {qlineServiceBlueprintOptions}
      onClose   = {close}
      onSaved   = {() => window.location.reload()}
    />
  )
}

export default FormModalManager
